"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const DocumentIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.722 1c-.336 0-.624.152-.863.457-.24.305-.359.67-.359 1.099v10.888c0 .428.12.794.359 1.1.24.304.527.456.863.456h8.556c.336 0 .624-.152.863-.457.24-.305.359-.67.359-1.099V4.667L9.833 1h-6.11zm5.5 1.556l3.056 2.888H9.222V2.556zM4.944 8.444h6.112V10H4.944V8.444zm0 3.112h6.112v1.555H4.944v-1.555z"
  })))
});
DocumentIcon.displayName = 'DocumentIcon';
var _default = exports.default = DocumentIcon;